/**
 * Estilos globales de Tailwind capturados por Parcel
 * e inyectados en una CSSStyleSheet compartida.
 */
import * as tailwindTextModule from 'bundle-text:../index.css';

const tailwindSheet = new CSSStyleSheet();
tailwindSheet.replaceSync(tailwindTextModule.default || tailwindTextModule);

// Estilos base adicionales si los necesitamos
const baseStyles = new CSSStyleSheet();
baseStyles.replaceSync(`
    :host {
        box-sizing: border-box;
    }
`);

export { tailwindSheet, baseStyles };